import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import {
  CompositeFilterDescriptor,
  process,
  State
} from "@progress/kendo-data-query";
import { BehaviorSubject } from "rxjs";
import { IUser, Role } from "src/app/interfaces";
import { isNullOrWhiteSpace } from "src/app/interfaces/string";
import { SubSink } from "subsink";
import { UserFacade } from "../services/user.facade";
@Component({
    selector: "user-admin-grid",
    templateUrl: "./admin-grid.component.html",
    standalone: false
})
export class AdminGridComponent implements OnInit, OnDestroy {
  public gridView$ = new BehaviorSubject<GridDataResult>(null);
  private filterValue: string = null;
  private subscriptions = new SubSink();
  public gridData: IUser[] = [];
  @Output()
  public editUser = new EventEmitter<IUser>();
  public state: State = {
    skip: 0,
    take: 15
  };
  constructor(private userfacade: UserFacade) {}
  ngOnInit(): void {
    this.userfacade.getAll().subscribe((x) => {
      this.gridData = x;
      this.loadGridView();
    });
  }
  public onEdit(s: IUser) {
    this.editUser.next(s);
  }
  private loadGridView() {
    if (!this.gridData) {
      this.gridView$.next(null);
      return;
    }

    this.gridView$.next(
      process(this.gridData, {
        filter: this.getFilter(this.filterValue)
      })
    );
  }

  private getFilter(value: string): CompositeFilterDescriptor {
    if (isNullOrWhiteSpace(value)) {
      return null;
    }

    return {
      logic: "or",
      filters: [
        {
          field: "displayName",
          operator: "contains",
          value: value
        },
        {
          field: "id",
          operator: "contains",
          value: value
        },
        {
          field: "login",
          operator: "contains",
          value: value
        },
        {
          field: "roles",
          operator: function (roles: Role[], value: string) {
            if (roles && roles.length > 0) {
              for (let i = 0; i < roles.length; i++) {
                if (roles[i].name.includes(value)) {
                  return true;
                }
              }
            }
            return false;
          },
          value: value
        }
      ]
    };
  }
  public onFilter(input: string): void {
    this.filterValue = input;
    this.loadGridView();
  }
  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
